import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { SkeletonLoader } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const widthMap = {
    phone: [
        '80%',
        '60%',
        '70%',
        '50%'
    ],
    default: [
        '50%',
        '30%',
        '40%',
        '20%'
    ]
};
const Image = /*#__PURE__*/ React.memo(({ isPhone , ariaLabel  })=>{
    const widths = isPhone ? widthMap.phone : widthMap.default;
    return /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "90px",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ React.createElement("rect", {
        width: widths[0],
        height: "15px",
        rx: "5",
        fill: "currentColor",
        y: "0"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: widths[1],
        height: "15px",
        rx: "5",
        fill: "currentColor",
        y: "30"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: widths[2],
        height: "15px",
        rx: "5",
        fill: "currentColor",
        y: "60"
    }));
});
const PrescriptionLoader = ()=>{
    const isPhone = MediaQuery.useIsPhone();
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(SkeletonLoader, null, /*#__PURE__*/ React.createElement(Image, {
        isPhone: isPhone,
        ariaLabel: getLabel('common.loadingText')
    }));
};

export { PrescriptionLoader };
//# sourceMappingURL=PrescriptionLoader.js.map
